/* tslint:disable */
 
import { FileModel } from './file-model';
import { LocalizedValue } from './localized-value';
export class DataEntityExportTemplate {
  additionalProperties?: null | {
};
  exportType: 0 | 1;
  file: null | FileModel;
  id?: string;
  level: 0 | 1;
  name: LocalizedValue;
  type: 0 | 1 | 2;
}
